import { render, staticRenderFns } from "./bottomLeftMid.vue?vue&type=template&id=3818c948&scoped=true&"
import script from "./bottomLeftMid.vue?vue&type=script&lang=js&"
export * from "./bottomLeftMid.vue?vue&type=script&lang=js&"
import style0 from "./bottomLeftMid.vue?vue&type=style&index=0&id=3818c948&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3818c948",
  null
  
)

export default component.exports